import { Button, Card, Stack, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
import CampaignsTable from './components/CampaignsTable';
import CreateCampaignModal from './components/CreateCampaignModal';
import { Campaign, useCampaigns } from './hooks/useCampaigns';

export default function CampaignsPage(): JSX.Element {
  const theme = useTheme();
  const { organizationId } = useParams<{ organizationId: string }>();

  const navigate = useNavigate();
  const { campaigns, isLoading, refetch } = useCampaigns(organizationId || '');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleRowClick = (campaign: Campaign): void => {
    navigate(
      PATH_DASHBOARD.general.organizations.campaign(
        organizationId || '',
        campaign.id,
      ),
    );
  };

  const handleUpdated = (): void => {
    refetch();
  };

  return (
    <>
      <Card
        sx={{
          height: '100%',
          display: 'flex',
          flex: 1,
          boxShadow: theme.customShadows.z24,
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px', flex: 1 }}>
          <Stack
            sx={{ minHeight: '84px' }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            p={3}
          >
            <Typography variant="h6">Kampanie Google Ads</Typography>
            <Button
              size="small"
              variant="contained"
              sx={{
                background: theme.palette.common.black,
                color: theme.palette.common.white,
              }}
              startIcon={<Iconify icon="mdi:add" />}
              onClick={() => setIsCreateModalOpen(true)}
            >
              Nowa kampania
            </Button>
          </Stack>

          <CampaignsTable
            campaigns={campaigns || []}
            isLoading={isLoading}
            onRowClick={handleRowClick}
          />
        </Stack>
      </Card>

      <CreateCampaignModal
        open={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        organizationId={organizationId || ''}
        onCreated={handleUpdated}
      />
    </>
  );
}
